<p class="text-xs mb-1">
  Enter the name(s) you buy properties under. Use your LLC name(s), or your full
  legal name if you purchase personally. Select all that apply.<sup
    class="text-red-500 ml-1"
    >*</sup
  >
</p>
<app-shared-search-multi-selector
  (searchChange)="handleSearchChange($event)"
  [options]="options"
  [selected]="selected"
  (selectedChange)="handleSelectedChange($event)"
  [loading]="loading ? 'Loading...' : undefined"
  placeholder="Enter at least 3 characters to search..."
  [errors]="errors"
  [touched]="touched"
  [disabled]="disabled"
  [yPosition]="yPosition"
></app-shared-search-multi-selector>
